const SHAPE_TYPES = [
	{ value: "square", label: "Cuadrado" },
	{ value: "circle", label: "Círculo" },
	{ value: "triangle", label: "Triángulo" },
	{ value: "line", label: "Línea" },
];

/** Plantillas de botón y pista (como en PRUEBA 1 y PRUEBA1_PLANTILLAS) */
const BUTTON_TEMPLATES = [
	{
		label: "Flecha adelante",
		desc: "Círculo rojo con flecha (tirar hacia adelante)",
		overrides: {
			width: 70,
			height: 70,
			content: { action: "nextPage", label: "", icon: "arrowRight", iconPosition: "after", iconSize: 1.5 },
			style: {
				fontFamily: "Arial, sans-serif",
				fontSize: 16,
				fontWeight: "bold",
				color: "rgba(255,255,255,1)",
				backgroundColor: "rgba(242,71,71,1)",
				textAlign: "center",
				borderRadius: 50,
			},
		},
	},
	{
		label: "Jugar",
		desc: "Botón de iniciar partida (página 1)",
		overrides: {
			width: 160,
			height: 44,
			content: { action: "nextPage", label: "Jugar", icon: "play", iconPosition: "before" },
			style: {
				fontFamily: "Arial, sans-serif",
				fontSize: 16,
				fontWeight: "bold",
				color: "rgba(51, 51, 51, 1)",
				backgroundColor: "rgba(255,250,250,1)",
				textAlign: "center",
				borderRadius: 8,
			},
		},
	},
];
/** Temas de plantillas: blanco/rojo (API), azul oscuro y caso medico (escape rooms dedicados, páginas 1–4). */
const PLANTILLA_TEMAS = [
	{ id: "blanco-rojo", label: "Blanco / Rojo" },
	{ id: "azul", label: "Azul oscuro" },
	{ id: "caso-medico", label: "Caso Médico" },
];

const ADD_PAGE_BLANCO_THEME_ID = "blanco";

const ADD_PAGE_DIALOG_TEMAS = [
	{ id: ADD_PAGE_BLANCO_THEME_ID, label: "Blanco" },
	...PLANTILLA_TEMAS,
];

const BLANK_PAGE_ADD_TEMPLATE = {
	name: "Página en blanco",
	design: {
		backgroundColor: "#ffffff",
		backgroundImageUrl: "",
		backgroundImageOpacity: 100,
		elements: [],
		timerRuns: true,
	},
};

const buildPageWithBackgroundAddTemplate = (refPage) => {
	const bg = refPage || {};
	return {
		name: "Página con fondo",
		design: {
			backgroundColor: bg.backgroundColor ?? "#ffffff",
			backgroundImageUrl: bg.backgroundImageUrl ?? "",
			backgroundImageOpacity: bg.backgroundImageOpacity ?? 100,
			elements: [],
			timerRuns: true,
		},
	};
};

const getPlantillaThemeSwatchStyle = (themeId) => {
	if (themeId === "azul") return { background: "linear-gradient(135deg, #3b82f6 0%, #0c1929 100%)" };
	if (themeId === "caso-medico") return { background: "#0f4c5c" };
	if (themeId === ADD_PAGE_BLANCO_THEME_ID) return { background: "#ffffff", border: "1px solid #e2e8f0" };
	return { background: "linear-gradient(90deg, #ffffff 50%, #ef4444 50%)" };
};

const getPlantillaThemeRingColor = (themeId) => {
	if (themeId === "azul") return "#3b82f6";
	if (themeId === "caso-medico") return "#0f4c5c";
	if (themeId === ADD_PAGE_BLANCO_THEME_ID) return "#94a3b8";
	return "#ef4444";
};

/** ID del escape room "AZUL": sus páginas 1–4 se usan como plantillas tema azul (referencian quiz, etc.). */
const AZUL_ESCAPE_ROOM_ID = "69a8047cb5cb1d4d687559ee";
/** ID fijo del escape room "Caso Médico" (todas sus páginas salvo registro). */
const CASO_MEDICO_ESCAPE_ROOM_ID = "69b90f10e1f3ed4c605c823e";

const HINT_TEMPLATES = [
	{
		label: "Pista estándar",
		desc: "Pista con modal de confirmación y penalización (como en Pregunta con pista)",
		overrides: {
			width: 120,
			height: 40,
			content: {
				label: "Pista",
				hintText: "Se parece mucho a nuestro personaje",
				hintPenalty: 10,
				confirmModalDesign: {
					backgroundColor: "#ffffff",
					borderRadius: 12,
					elements: [
						{ elementId: "h1", type: "text", x: 9, y: 69, width: 623, height: 83, content: { html: "<p>¿Estás seguro de que quieres usar una pista?</p>" }, style: { fontFamily: "Arial, sans-serif", fontSize: 25, color: "#000000", backgroundColor: "transparent", fontWeight: "bold", textAlign: "center" } },
						{ elementId: "h2", type: "shape", x: -15, y: -3, width: 709, height: 63, content: { shapeType: "square", fillColor: "rgba(255,99,99,1)", strokeColor: "rgba(0, 0, 0, 1)", strokeWidth: 0, borderRadius: 0 } },
						{ elementId: "h3", type: "button", x: 24, y: 420, width: 160, height: 44, content: { action: "cancelHint", label: "Cancelar", icon: "", iconPosition: "before" }, style: { fontFamily: "Arial, sans-serif", fontSize: 16, fontWeight: "bold", color: "rgba(51, 51, 51, 1)", backgroundColor: "transparent", textAlign: "center", borderRadius: 8 } },
						{ elementId: "h4", type: "button", x: 456, y: 420, width: 160, height: 44, content: { action: "confirmHint", label: "Confirmar", icon: "", iconPosition: "before" }, style: { fontFamily: "Arial, sans-serif", fontSize: 16, fontWeight: "bold", color: "rgba(255, 255, 255, 1)", backgroundColor: "rgba(237,57,57,1)", textAlign: "center", borderRadius: 8 } },
					],
				},
				confirmModalSize: "medium",
				hintModalDesign: {
					backgroundColor: "#ffffff",
					borderRadius: 12,
					elements: [
						{ elementId: "h5", type: "shape", x: 245, y: 50, width: 150, height: 150, content: { shapeType: "circle", fillColor: "rgba(255,254,182,0.8)", strokeColor: "rgba(0, 0, 0, 1)", strokeWidth: 0, borderRadius: 0 } },
						{ elementId: "h6", type: "text", x: 271, y: 77, width: 99, height: 119, content: { html: "💡<p></p>" }, style: { fontFamily: "League Spartan, sans-serif", fontSize: 60, color: "#dc9c0c", backgroundColor: "transparent", fontWeight: "bold", textAlign: "left" } },
						{ elementId: "h7", type: "text", x: 138, y: 239, width: 365, height: 126, content: { html: "<p>PISTA: <span style=\"font-weight: normal;\">Se parece mucho a nuestro protagonista</span></p>" }, style: { fontFamily: "Arial, sans-serif", fontSize: 28, color: "#000000", backgroundColor: "transparent", fontWeight: "bold", textAlign: "center" } },
					],
				},
				hintModalSize: "medium",
			},
			style: {
				fontFamily: "Arial, sans-serif",
				fontSize: 14,
				fontWeight: "bold",
				color: "rgba(255,99,99,0.8)",
				backgroundColor: "rgba(255,217,217,0.8)",
				textAlign: "center",
				borderRadius: 8,
				borderColor: "rgba(255,133,133,1)",
				borderWidth: 2,
			},
		},
	},
];

const FONT_OPTIONS = [
	"League Spartan, sans-serif",
	"Arial, sans-serif",
	"'Anton', sans-serif",
	"'Bebas Neue', sans-serif",
	"Georgia, serif",
	"Times New Roman, serif",
	"Verdana, sans-serif",
	"Courier New, monospace",
	"Impact, sans-serif",
	"Comic Sans MS, cursive",
];
const ADD_FONT_OPTION = "__add_font__";

export {
	SHAPE_TYPES,
	BUTTON_TEMPLATES,
	PLANTILLA_TEMAS,
	ADD_PAGE_BLANCO_THEME_ID,
	ADD_PAGE_DIALOG_TEMAS,
	BLANK_PAGE_ADD_TEMPLATE,
	buildPageWithBackgroundAddTemplate,
	getPlantillaThemeSwatchStyle,
	getPlantillaThemeRingColor,
	AZUL_ESCAPE_ROOM_ID,
	CASO_MEDICO_ESCAPE_ROOM_ID,
	HINT_TEMPLATES,
	FONT_OPTIONS,
	ADD_FONT_OPTION,
};
